// biome-ignore lint/style/noRestrictedImports: encapsulation
import type { Range } from "@tanstack/react-virtual";

import { max } from "~/tools/max";
import { min } from "~/tools/min";
import { range } from "~/tools/range";

export interface BufferedRange {
	bufferStartIndex: number;
	bufferEndIndex: number;
}

export function getBufferedIndexes(
	{ startIndex, endIndex, overscan, count }: Range,
	bufferedRange: BufferedRange = { bufferStartIndex: startIndex, bufferEndIndex: endIndex },
): Array<number> {
	const rangeStart =
		startIndex - bufferedRange.bufferStartIndex > overscan * 4 || startIndex - bufferedRange.bufferStartIndex < overscan
			? startIndex - overscan * 2
			: bufferedRange.bufferStartIndex;

	const rangeEnd =
		bufferedRange.bufferEndIndex - endIndex > overscan * 4 || bufferedRange.bufferEndIndex - endIndex < overscan
			? 1 + endIndex + overscan * 2
			: 1 + bufferedRange.bufferEndIndex;

	return range(max(0, rangeStart), min(count, rangeEnd));
}
